import FileUpload from './FileUpload';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { format } from 'util';
import { Button, ButtonGroup, Dialog, DialogContent, DialogTitle } from '@mui/material';

interface IOntimeDropzoneDialog {
    openDropzone: boolean;
    acceptedFiles: string[] | undefined;
    handleSave: (dropFiles: File[]) => void;
    handleClose: (e: any) => void;
    dialogTitle: string;
    filesLimit?: number;
}

function OntimeDropzoneDialog(props: IOntimeDropzoneDialog) {
    const { t } = useTranslation("common");
    const [files, setFiles] = useState<File[]>([]);
    return (
        <Dialog open={props.openDropzone} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">{props.dialogTitle}</DialogTitle>
            <DialogContent>
                <FileUpload
                    value={files}
                    onChange={setFiles}
                    maxSize={5000000}
                    accept={props.acceptedFiles}
                    buttonText={t<string>("commonLabels.dropfiles")}
                    title={props.dialogTitle}
                    onDropRejected={(fileRejections, event) => format(t<string>("commonLabels.fileDropRejected"), fileRejections[0].file.name)}
                />

                <ButtonGroup>
                    <Button onClick={(e) => props.handleSave(files)}>{t("commonActions.ok")}</Button>
                    <Button onClick={props.handleClose}>{t("commonActions.cancel")}</Button>
                </ButtonGroup>
            </DialogContent>
        </Dialog>
    );
    // <DropzoneDialog
    //     open={props.openDropzone}
    //     onSave={props.handleSave}
    //     acceptedFiles={props.acceptedFiles}
    //     showPreviews={true}
    //     maxFileSize={5000000}
    //     dialogTitle={props.dialogTitle}
    //     dropzoneText={t("commonLabels.dropfiles")}
    //     previewText={t("commonLabels.preview")}
    //     cancelButtonText={t("commonActions.cancel")}
    //     submitButtonText={t("commonActions.ok")}
    //     getFileAddedMessage={(fileName: string) => format(t("commonLabels.fileAdded"), fileName)}
    //     getFileRemovedMessage={(fileName: string) => format(t("commonLabels.fileRemoved"), fileName)}
    //     getDropRejectMessage={(rejectedFile: File, acceptedFiles: string[], maxFileSize: number) => format(t("commonLabels.fileDropRejected"), rejectedFile.name)}
    //     onClose={props.handleClose}
    //     filesLimit={props.filesLimit}
    // />);
}

export default OntimeDropzoneDialog;